export default {
  apiKey: process?.env?.VUE_APP_FIREBASE_API_KEY || '',
  authDomain: process?.env?.VUE_APP_FIREBASE_AUTH_DOMAIN || '',
  databaseURL: process?.env?.VUE_APP_FIREBASE_DATABASE_URL || '',
  storageBucket: process?.env?.VUE_APP_FIREBASE_STORAGE_BUCKET || '',
  projectId: process?.env?.VUE_APP_FIREBASE_PROJECT_ID || '',
  messagingSenderId: process?.env?.VUE_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process?.env?.VUE_APP_FIREBASE_APP_ID || '',
}
